import api from '@/api/api'

const state = {
    annualTypeList: [],
    congratulatoryRules: [
        { label: '본인 결혼', days: '5일' },
        { label: '자녀 결혼', days: '1일' },
        { label: '형제/자매 결혼', sub: '본인 및 배우자 형제/자매', days: '1일' },
        { label: '자녀 출산', days: '규칙 참조' },
    ],
    condolenceRules: [
        { label: '배우자 사망', days: '5일' },
        { label: '부모 사망', sub: '배우자 부모 포함', days: '5일' },
        { label: '자녀 사망', sub: '자녀의 배우자 포함', days: '5일' },
        { label: '조부모/외조부모', days: '3일' },
        { label: '형제/자매 사망', sub: '배우자 형제/자매 포함', days: '3일' },
    ],
    allEmployees: []
}

const mutations = {
    SET_ANNUAL_TYPE_LIST(state, list) {
        state.annualTypeList = list
    },
    SET_ALL_EMPLOYEES(state, list) {
        state.allEmployees = list
    }
}

const actions = {
    getAnnualTypeList({ commit, state }) {
        if (state.annualTypeList.length > 0) return Promise.resolve(state.annualTypeList)

        const param = { clsCd: 'annual_cd' }
        return api.postGetComCdList(param)
            .then(res => {
                if (res && res.data && res.data.result && res.data.data) {
                    const list = res.data.data.list
                    commit('SET_ANNUAL_TYPE_LIST', list)
                    return list
                }
                return []
            })
            .catch(err => {
                console.error('getAnnualTypeList Error:', err)
                return []
            })
    }
}

const commonStore = {
    namespaced: true,
    state,
    mutations,
    actions
}

export default commonStore
